import { render, staticRenderFns } from "./AdspotSupplier.vue?vue&type=template&id=14dd0f27&scoped=true&"
import script from "./AdspotSupplier.vue?vue&type=script&lang=js&"
export * from "./AdspotSupplier.vue?vue&type=script&lang=js&"
import style0 from "./AdspotSupplier.vue?vue&type=style&index=0&id=14dd0f27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd0f27",
  null
  
)

component.options.__file = "AdspotSupplier.vue"
export default component.exports